// extracted by mini-css-extract-plugin
module.exports = {"itemHeader":"serviceListItemSkeleton_itemHeader__3wcOw","title":"serviceListItemSkeleton_title__qVprH"};